import { useMemo } from 'react';
import { RedocStandalone } from 'redoc';
import { useTheme } from '@unity/cloud-ui/styles';
import { Box } from '@unity/cloud-ui';
import { darkPalette } from '@unity/cloud-ui/theme';
import themeConstants from '@/components/theme/theme-constants';

export interface RedocStandaloneProps {
  specPath: string;
  testJson?: object;
}

export const OpenAPI = function (props: RedocStandaloneProps) {
  const { specPath } = props;
  const theme = useTheme();

  // Convert Unity theme to Redoc theme configuration
  const redocTheme = useMemo(
    () => ({
      colors: {
        primary: {
          main: theme.palette.primary.main,
        },
        text: {
          primary: theme.palette.text.primary,
          secondary: theme.palette.text.secondary,
        },
      },
      typography: {
        fontSize: `${theme.typography.fontSize}px`,
        fontFamily: theme.typography.fontFamily || 'inherit',
      },
      sidebar: {
        backgroundColor: theme.palette.background.paper,
        textColor: theme.palette.text.primary,
      },
      rightPanel: {
        backgroundColor: darkPalette.background.paper,
        width: '40%',
        textColor: darkPalette.text.primary,
        panelTextColor: darkPalette.text.primary,
        servers: {
          overlay: {
            backgroundColor: darkPalette.background.paperElevation1,
            textColor: darkPalette.text.primary,
          },
          url: {
            backgroundColor: darkPalette.background.paperElevation4,
          },
        },
      },
    }),
    [
      theme.palette.primary.main,
      theme.palette.text.primary,
      theme.palette.text.secondary,
      theme.palette.background.paper,
      theme.typography.fontSize,
      theme.typography.fontFamily,
    ],
  );

  if (specPath) {
    return (
      <Box
        sx={{
          '.redoc-wrap h5': {
            color: `${theme.palette.text.secondary} !important`,
          },
          '.redoc-wrap h5 span': {
            color: `${theme.palette.text.primary} !important`,
          },
          '.redoc-wrap ul.react-tabs__tab-list li': {
            color: `#1e1e1e !important`,
          },
          '.redoc-wrap > .menu-content': {
            top: `calc(${themeConstants.layout.headerHeight} + ${themeConstants.layout.productHeaderHeight}) !important`,
          },
        }}
      >
        <RedocStandalone specUrl={specPath} options={{ theme: redocTheme }} />
      </Box>
    );
  }
  return null;
};
